import { render } from "./AccountsBasicInfoEditor.vue?vue&type=template&id=3bc39604"
import script from "./AccountsBasicInfoEditor.vue?vue&type=script&lang=js"
export * from "./AccountsBasicInfoEditor.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__